import { apiPromiseTypes } from 'redux/middleware/api-promise/action-types';

export const GET_QUICK_SHOP_WIDGET_SUGGESTIONS = apiPromiseTypes(
  'basket-builder-experience-quick-shop-widget',
  'get',
);
